import { render } from "./ViewerView.vue?vue&type=template&id=6cb92b07"
import script from "./ViewerView.vue?vue&type=script&lang=js"
export * from "./ViewerView.vue?vue&type=script&lang=js"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__